import React from 'react';
import { formatCurrency, formatPercent } from '../lib/executiveCommandCenterFormatters';

const MiniBar = ({ label, value, max = 100, colorClass = 'bg-cyan-400' }) => {
  const width = Math.max(3, Math.min(100, (Number(value || 0) / Math.max(Number(max || 1), 1)) * 100));
  return (
    <div>
      <div className="mb-1 flex items-center justify-between text-xs text-slate-400">
        <span>{label}</span>
        <span>{formatCurrency(value)}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-800">
        <div className={`h-full rounded-full ${colorClass}`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
};

const RevenueCollectionPanel = ({ data }) => {
  const info = data || {};
  const aging = info.overdue_aging_buckets || {};
  const agingMax = Math.max(
    Number(aging['0_30'] || 0),
    Number(aging['31_60'] || 0),
    Number(aging['61_90'] || 0),
    Number(aging['90_plus'] || 0),
    1,
  );

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Revenue & Collection Health</h3>
      <div className="mt-3 grid gap-3 md:grid-cols-4">
        <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
          <div className="text-xs text-slate-400">Paid Customers</div>
          <div className="mt-1 text-lg font-semibold text-emerald-200">{Number(info.paid_customers || 0).toLocaleString('id-ID')}</div>
        </div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
          <div className="text-xs text-slate-400">Unpaid Customers</div>
          <div className="mt-1 text-lg font-semibold text-amber-200">{Number(info.unpaid_customers || 0).toLocaleString('id-ID')}</div>
        </div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
          <div className="text-xs text-slate-400">Overdue Amount</div>
          <div className="mt-1 text-lg font-semibold text-red-300">{formatCurrency(info.overdue_amount)}</div>
        </div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
          <div className="text-xs text-slate-400">Collection Efficiency</div>
          <div className="mt-1 text-lg font-semibold text-cyan-200">{formatPercent(info.collection_efficiency)}</div>
          <div className="text-xs text-slate-500">Revenue at risk {formatCurrency(info.revenue_at_risk_from_unpaid)}</div>
        </div>
      </div>
      <div className="mt-4 space-y-2">
        <MiniBar label="Overdue 0-30 hari" value={aging['0_30'] || 0} max={agingMax} colorClass="bg-amber-300" />
        <MiniBar label="Overdue 31-60 hari" value={aging['31_60'] || 0} max={agingMax} colorClass="bg-orange-400" />
        <MiniBar label="Overdue 61-90 hari" value={aging['61_90'] || 0} max={agingMax} colorClass="bg-red-400" />
        <MiniBar label="Overdue >90 hari" value={aging['90_plus'] || 0} max={agingMax} colorClass="bg-rose-500" />
      </div>
    </section>
  );
};

export default RevenueCollectionPanel;
